export default "__VITE_ASSET__BuBi2FN4__"